import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { CheckCircle, XCircle, Loader2 } from "lucide-react";
import api from "../../services/api";

const AssetEmailVerify = () => {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState("loading"); // loading | success | error
  const [message, setMessage] = useState("");

  useEffect(() => {
    const id = params.get("id");
    const token = params.get("token");

    if (!id || !token) {
      setStatus("error");
      setMessage("Invalid verification link.");
      return;
    }

    api
      .verifyMonitoredAsset(id, token)
      .then(() => {
        setStatus("success");
        setMessage("Email verified! Monitoring has started.");
      })
      .catch((err) => {
        setStatus("error");
        setMessage(
          err.response?.data?.message || "Verification failed or link expired.",
        );
      });
  }, []);

  return (
    <div className="min-h-screen bg-[#0C0E12] flex items-center justify-center">
      <div className="bg-[#12151C] border border-white/10 rounded-xl p-10 max-w-md w-full text-center">
        {status === "loading" && (
          <>
            <Loader2
              className="animate-spin text-violet-400 mx-auto mb-4"
              size={40}
            />
            <p className="text-gray-400">Verifying your email…</p>
          </>
        )}
        {status === "success" && (
          <>
            <CheckCircle className="text-green-400 mx-auto mb-4" size={40} />
            <h2 className="text-white text-xl font-bold mb-2">Verified!</h2>
            <p className="text-gray-400 mb-6">{message}</p>
            <button
              onClick={() => navigate("/darkweb/emails")}
              className="px-6 py-2 bg-violet-500 hover:bg-violet-600 text-white rounded-lg font-mono text-sm transition-all"
            >
              Go to Monitored Emails
            </button>
          </>
        )}
        {status === "error" && (
          <>
            <XCircle className="text-red-400 mx-auto mb-4" size={40} />
            <h2 className="text-white text-xl font-bold mb-2">
              Verification Failed
            </h2>
            <p className="text-gray-400 mb-6">{message}</p>
            <button
              onClick={() => navigate("/darkweb/emails")}
              className="px-6 py-2 bg-white/10 hover:bg-white/20 text-gray-300 rounded-lg font-mono text-sm transition-all"
            >
              Back to Dashboard
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default AssetEmailVerify;
